// extracted by mini-css-extract-plugin
export default {"pageLoading":"PageLoading_pageLoading__2IKdu","brandName":"PageLoading_brandName__SQKCQ","spinner":"PageLoading_spinner__4Z+li","spin":"PageLoading_spin__2G1n1"};